import { useMemo } from 'react';

export function useItemButtonStateModule({
    itemValidation,

    bloqueadoPorLimite = false,
    bloqueadoPorEstoque = false,

    bloqueadoPorPreco = false,
    bloqueadoPorDesconto = false,
    //bloqueios da NF
    bloqueadoPorXml = false,
    bloqueadoPorOutraRegra = false,

    itemSalvando = false,
    formSalvando = false,
    editandoItem = false,
}) {
    const state = useMemo(() => {
        const podeSalvarItemBase = !!itemValidation?.podeSalvarItemBase;

        let motivoBloqueioItem = itemValidation?.motivoBloqueioItem || null;

        if (!motivoBloqueioItem) {
            if (bloqueadoPorLimite) motivoBloqueioItem = 'Limite do centro de custo indisponível.';
            else if (bloqueadoPorPreco) motivoBloqueioItem = 'Preço abaixo da tabela.';
            else if (bloqueadoPorDesconto) motivoBloqueioItem = 'Preço menor que o permitido pela tabela de preços.';
            else if (bloqueadoPorEstoque) motivoBloqueioItem = 'Estoque indisponível.';
            else if (bloqueadoPorXml) motivoBloqueioItem = 'Existem itens do XML pendentes de vínculo.';
            else if (bloqueadoPorOutraRegra) motivoBloqueioItem = 'Item bloqueado por regra da operação.';
            else if (itemSalvando) motivoBloqueioItem = 'Processando item.';
        }

        const disabledBtnItem =
            !podeSalvarItemBase ||
            bloqueadoPorLimite ||
            bloqueadoPorPreco ||
            bloqueadoPorDesconto ||
            bloqueadoPorEstoque ||
            bloqueadoPorOutraRegra ||
            itemSalvando;

        const disabledBtnForm = itemSalvando || editandoItem || formSalvando;
        const bloqueioAcaoGlobal = itemSalvando || formSalvando;

        return {
            disabledBtnItem,
            disabledBtnForm,
            bloqueioAcaoGlobal,
            bloqueadoPorXml,
            motivoBloqueioItem,
        };
    }, [
        itemValidation,
        bloqueadoPorLimite,
        bloqueadoPorEstoque,
        bloqueadoPorPreco,
        bloqueadoPorDesconto,
        bloqueadoPorOutraRegra,
        bloqueadoPorXml,
        itemSalvando,
        formSalvando,
        editandoItem,
    ]);

    return { state };
}
